<!-- 商品列表【抢购】 -->

<template>
    <div :style="css">
        <div class='container good_list_box'>
            <div class="good_box" v-for="(item, index) in goodList" :key="index" @click.stop="toGoodDetail(item, 1)">
                <!-- <div class="progre">40%</div> -->
                <div class="img_box">
                    <img :src="item.thumbnailCommon" alt="">
                    <!-- <img src="@/assets/images1/39.png" alt=""> -->
                </div>
                <div class="info_box">
                    <div class="line_box">
                        <span>product name</span>
                        <span>{{ item.name || "" }}</span>
                    </div>
                    <div class="line_box">
                        <span>Coil</span>
                        <span>{{ item.smokeType }}</span>
                    </div>
                    <div class="line_box">
                        <span>E-Liquid</span>
                        <span>{{ item.capacity }}</span>
                    </div>
                    <div class="line_box">
                        <span>Puffs</span>
                        <span>{{ item.smokeNum }}</span>
                    </div>
                    <!-- <div class="line_box">
                        <span>nicotine content</span>
                        <span>{{ item.nicotines[0].content }}</span>
                    </div> -->
                    <div class="line_box">
                        <span>battery</span>
                        <span>{{ item.battery }}</span>
                    </div>
                    <div class="line_box" style="margin-top: 16px;">
                        <span style="color: #FA14D5;font-size: 12px;">Time</span>
                        <div class="time_box">
                            <div class="it">{{ countDownList[index].day }}</div>
                            :
                            <div class="it">{{ countDownList[index].hou }}</div>
                            :
                            <div class="it">{{ countDownList[index].min }}</div>
                            :
                            <div class="it">{{ countDownList[index].sec }}</div>
                        </div>
                    </div>
                    <div class="car_box">
                        <p>
                            <span>$</span>
                            <span class="num">{{ item.price }}</span>
                        </p>
                        <!-- @click.stop="goBuy(item)" -->
                        <div class="btn">Buy now</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        css: String,
        /** 商品列表 */
        goodList: { type: Array, default() { return [] } },
        Time: { type: Array, default() { return [] } }
    },
    data() {
        return {
            timerId: null,// 初始化定时器ID为null
            countDownList: [],
        }
    },
    beforeDestroy() {
        this.stopTimer(); // 在组件销毁前清除定时器
    },
    created() {
        // console.warn(this.Time, "Time");
        this.countDown();
    },
    methods: {
        async goBuy(item) {
            console.warn(item, "ite11111s")
            // return
            sessionStorage.setItem("QUICK_BUY_DATA", JSON.stringify(
                {
                    num: item.number, //数量
                    allPrice: Number(item.price),  //订单总价格
                    goodsId: item.goodsId, //商品id
                    smokeType: item.smokeType,
                    nicotineId: item.nicotines[0].nicotineId, //尼古丁id
                    nicotineName: item.nicotines[0].content,
                    falvorList: [{
                        buyNum: 1,
                        falvorId: item.flavors[0].falvorId,
                        flavorName: item.flavors[0].flavorName,
                        thumbnail: item.flavors[0].flavorThumbnail
                    }]
                }
            ))
            this.$router.push('/home/carsure');
        },
        stopTimer() {
            clearInterval(this.timerId); // 清除定时器
            this.timerId = null; // 重置定时器ID为null
        },
        //小于10的格式化函数
        timeFormat(times) {
            return times < 10 ? '0' + times : times;
        },
        //倒计时函数
        countDown() {
            // 获取当前时间，同时得到活动结束时间数组
            let newTime = new Date().getTime();
            let endTimeList = this.Time;
            let countDownArr = [];

            // 对结束时间进行处理渲染到页面
            endTimeList.forEach(o => {

                let endTime = new Date(o.eTime).getTime();
                let obj = null;
                // 如果活动未结束，对时间进行处理
                if (endTime - newTime > 0) {
                    let time = (endTime - newTime) / 1000;
                    // 获取天、时、分、秒
                    let day = parseInt(time / (60 * 60 * 24));
                    let hou = parseInt(time % (60 * 60 * 24) / 3600);
                    let min = parseInt(time % (60 * 60 * 24) % 3600 / 60);
                    let sec = parseInt(time % (60 * 60 * 24) % 3600 % 60);
                    // console.warn(day)
                    obj = {
                        day: this.timeFormat(day),
                        hou: this.timeFormat(hou),
                        min: this.timeFormat(min),
                        sec: this.timeFormat(sec)
                    }
                } else { //活动已结束，全部设置为'00'
                    obj = {
                        day: '00',
                        hou: '00',
                        min: '00',
                        sec: '00'
                    }
                }
                countDownArr.push(obj);
            })
            // console.warn(countDownArr, 'countDownArr')
            this.countDownList = countDownArr
            // 渲染，然后每隔一秒执行一次倒计时函数
            this.timerId = setTimeout(this.countDown, 1000);
        },


    },
}
</script>

<style lang='scss' scoped>
.good_list_box {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 40px;
    grid-row-gap: 40px;

    .good_box {
        // height: 500px;
        background: #ffffff;
        border-radius: 16px;
        box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.08);
        position: relative;

        .progre {
            width: 74px;
            height: 74px;
            background: url('~@/assets/images1/40.png') no-repeat;
            background-size: 100% 100%;
            position: absolute;
            right: -14px;
            top: -24px;
            z-index: 1;
            font-size: 20px;
            font-family: Inter, Inter-900;
            font-weight: 900;
            text-align: LEFT;
            color: #3736ea;
            line-height: 23px;
            box-sizing: border-box;
            padding: 30px 0 0 10px;
        }

        .img_box {
            height: 258px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;

            img {
                width: 236px;
                height: 236px;
            }
        }

        .info_box {
            padding: 24px 24px;
            font-size: 14px;
            font-family: Inter, Inter-400;
            font-weight: 400;
            text-align: LEFT;
            color: #12181d;
            line-height: 16px;

            .line_box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 12px;

                &:first-of-type {
                    margin-top: 0;
                }
            }

            .car_box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 16px;
                font-family: Inter, Inter-500;
                font-weight: 500;
                text-align: LEFT;
                color: #fa14d5;
                line-height: 19px;
                cursor: pointer;
                margin: 16px auto 0;

                .num {
                    font-size: 20px;
                    line-height: 23px;
                }

                p {
                    display: flex;
                    align-items: baseline;
                }

                .btn {
                    width: 91px;
                    height: 33px;
                    background: #f624d5 linear-gradient(90deg, #f624d5, #3437f7 100%);
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 14px;
                    font-family: Inter, Inter-400;
                    font-weight: 400;
                    text-align: CENTER;
                    color: #ffffff;
                }
            }
        }
    }
}

.time_box {
    display: flex;
    align-items: center;

    .it {
        width: 31px;
        height: 31px;
        background: rgba(246, 36, 213, 0.1);
        border: 0.5px solid #fa14d5;
        border-radius: 2px;
        box-sizing: border-box;
        font-size: 12px;
        font-family: Inter, Inter-400;
        color: #12181d;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 4px;

        &:last-of-type {
            margin-right: 0;
        }
    }
}
</style>
